import React from "react";
import { Drawer, Descriptions, Typography, Tag } from "antd";
import { fmtUnix } from "../log-utils";

const { Paragraph, Text } = Typography;

// Nhãn tiếng Việt cho các field hay gặp; field khác fallback về chính tên key.
const LABELS = {
    created_at: "Thời gian", error_type: "Loại lỗi", status_code: "Status",
    is_critical: "Critical", method: "Method", path: "Path", message: "Message",
    module: "Module", stack: "Stack", user_id: "User", userId: "User",
    ip_address: "IP", ip: "IP", user_agent: "User-Agent", userAgent: "User-Agent",
    clickId: "clickId", platform: "Platform", channel: "Kênh", source: "Source",
    os: "OS", appVersion: "App ver", targetUrl: "Target URL",
    resource: "Resource", action: "Action", ref_id: "Ref",
};

// Render giá trị 1 field: thời gian, link, critical → tô màu/định dạng phù hợp.
function renderValue(key, val) {
    if (val == null || val === "") return <Text type="secondary">-</Text>;
    if (key === "created_at") return fmtUnix(val);
    if (key === "is_critical") return val ? <Tag color="red">critical</Tag> : <Tag>thường</Tag>;
    if (key === "stack") {
        return (
            <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, margin: 0, maxHeight: 360, overflow: "auto" }}>
                {val}
            </pre>
        );
    }
    if ((key === "targetUrl" || key === "path") && String(val).startsWith("http")) {
        return <a href={val} target="_blank" rel="noreferrer">{val}</a>;
    }
    return <Paragraph copyable={{ text: String(val) }} style={{ margin: 0 }}>{String(val)}</Paragraph>;
}

// Drawer xem chi tiết 1 dòng log — render mọi field dạng Descriptions, generic
// nên dùng được cho cả Error/Click/Access.
function LogDetailDrawer({ row, title, onClose }) {
    return (
        <Drawer title={title} width={560} open={!!row} onClose={onClose} destroyOnClose>
            {row ? (
                <Descriptions column={1} size="small" bordered>
                    {Object.entries(row)
                        .filter(([k]) => k !== "id")
                        .map(([k, v]) => (
                            <Descriptions.Item key={k} label={LABELS[k] || k}>
                                {renderValue(k, v)}
                            </Descriptions.Item>
                        ))}
                </Descriptions>
            ) : null}
        </Drawer>
    );
}

export default LogDetailDrawer;
